import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    chartData: Object,
    optionsChart: Object,
    areaColor: { type: String, default: "" },
    areaColors: { type: Array, default: [] },
    heightChart: { type: Number, default: 150 },
  },
  data: () => ({
    interval: null,
  }),
  mounted() {
    if (this.areaColor != "" && this.areaColor[0] == "#") {
        this.gradient = this.$refs.canvas
          .getContext("2d")
          .createLinearGradient(0, 0, 0, this.heightChart);
        let gradientStep1 = this.areaColor;
        let gradientStep2 = this.areaColor + "7a";
        let gradientStep3 = this.areaColor + "00";
        for (let i = 0; i < this.chartData.datasets.length; i++) {
          this.gradient.addColorStop(0, gradientStep1);
          this.gradient.addColorStop(0.5, gradientStep2);
          this.gradient.addColorStop(1, gradientStep3);
          // console.log(this.gradient);

          this.chartData.datasets[i].backgroundColor = this.gradient;
        }
      }
      if (this.areaColors.length > 0) {
        for (let i = 0; i < this.chartData.datasets.length; i++) {
          this.gradient = this.$refs.canvas
            .getContext("2d")
            .createLinearGradient(0, 0, 0, this.heightChart);
          let gradientStep1 = this.areaColors[i];
          let gradientStep2 = this.areaColors[i] + "7a";
          let gradientStep3 = this.areaColors[i] + "00";

          this.gradient.addColorStop(0, gradientStep1);
          this.gradient.addColorStop(0.5, gradientStep2);
          this.gradient.addColorStop(1, gradientStep3);
          // console.log(this.gradient);

          this.chartData.datasets[i].backgroundColor = this.gradient;
        }
      }
    this.renderChart(this.chartData, this.optionsChart);
    this.interval = setInterval(() => {
      if (this.$data._chart) {
        this.$data._chart.update();
      }
    }, 2000);
  },
  updated() {
    console.log("update chart");
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
